import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Typography } from "@mui/material";
import CustomCard from "../CustomCardComponent/CustomCard";
import { Button } from "../Button";
import { useModal } from '../../hooks/useModal'
import { useOktaAuth } from "@okta/okta-react";
import {styled} from "@mui/material/styles";
import homePageContentData from "./homePageContentData.json";

const ContentContainer = styled('div')(({ theme: { breakpoints } }) => `
    display: flex;
    padding: 32px;
    flex-wrap: wrap;
    flex-direction: row;
    ${breakpoints.down('sm')} {
        flex-direction: column; 
        padding: 10px 32px; 
        margin-top: 0; 
    }
`);

export const MResviaCard = () => {
    const locale = useSelector((state) => state.globalStates.locale);
    const history = useHistory();
    const { authState } = useOktaAuth() || "";
    const isAuthenticated = authState?.isAuthenticated;
    const { handleOpenModal } = useModal();

    const navigateOrLogin = (path) => {
        if (isAuthenticated) {
          history.push(`/${locale}/${path}`);
        } else {
          handleOpenModal(`/${locale}/${path}`);
        }
      };

    const onOrderNowClick = () => {
        navigateOrLogin('order-form');
    }

    const OrderBanner = ({ text }) => (
        <div>
            <Typography
                gutterBottom
                component="div"
                fontSize={{ xs: '16px', sm: '16px', md: '20px', lg: '24px' }}
                fontFamily="Aeonik Regular"
                fontWeight={700}
                mb={3}
            >
                {text}
            </Typography>
            <Button
                buttonType="mds-outline"
                sx={{ textTransform: "none", padding: "16px 32px", width: "fit-content" }}
                onClick={onOrderNowClick}
            >
                Order now
            </Button>
        </div>
    );

    return (
        <CustomCard>
            <ContentContainer>
                <OrderBanner text={homePageContentData.orderBannerText} />
            </ContentContainer>
        </CustomCard>
    );
};